<template>
  <div>
    <span
      v-for="char in nearQuestions"
      :key="char"
      class="near-question"
      :class="questionClass(char)"
    >
      {{ char }}
    </span>
  </div>
</template>

<style scoped>
.near-question {
  background: var(--v-accent-base);;
  border-radius: 50%;
  color: white;
  display: inline-block;
  font-size: 48px;
  font-weight: 700;
  height: 64px;
  line-height: 64px;
  margin: 4px;
  text-align: center;
  text-transform: uppercase;
  width: 64px;
}
.near-question:not(:first-child) {
  opacity: .2;
}

  .answer-error .near-question:first-child,
  .near-question.question-error {
    background: var(--v-error-base);;
  }
  .answer-success .near-question:first-child,
  .near-question.question-success {
    background: var(--v-success-darken2);;
  }

@media screen and (max-width: 410px) {
  .near-question {
    font-size: 24px;
    height: 42px;
    line-height: 42px;
    width: 42px;
  }
}
</style>

<script>
import circular from '@/helpers/circular';

function nextUnansweredQuestion(questions, current) {
  if (!questions || !current) {
    return null;
  }

  const abc = Object.keys(questions);
  let next = circular.next(abc, current);

  // If next answer is already answered, find the next one
  while (questions[next] && questions[next].answered && next !== current) {
    next = circular.next(abc, next);
  }

  return next;
}

export default {
  name: 'NearQuestions',
  computed: {
    questions() {
      return this.$store.state.rondo.list[this.$i18n.locale] || {};
    },
    nearQuestions() {
      const nearQuestions = [];
      const { current } = this.$store.state.rondo;
      const next = nextUnansweredQuestion(this.questions, current);
      const following = nextUnansweredQuestion(this.questions, next);

      if (current) {
        nearQuestions.push(current);
      }
      if (next !== current) {
        nearQuestions.push(next);
      }
      if (following !== current && following !== next) {
        nearQuestions.push(following);
      }

      return nearQuestions;
    },
  },
  methods: {
    questionClass(q) {
      const question = this.$store.state.rondo.list[this.$i18n.locale][q];
      if (question && question.answered) {
        return question.success ? 'question-success' : 'question-error';
      }

      return 'question-remaining';
    },
  },
};
</script>
